export default function adaptCompanyFromDetail({
  companyName,
  country,
  insuranceProducts,
  benefitConfigs,
  wellnessBenefits,
  retirementInsuranceBenefit,
  pensionPlanBenefit,
  ...rest
}) {
  return {
    name: companyName,
    countryISO2Code: country?.ISO2Code || "ES",
    modalities: insuranceProducts,
    extraBenefits: {
      renting: benefitConfigs["renting-benefit"]?.enabled || false,
      "life-insurance":
        benefitConfigs["life-insurance-benefit"]?.enabled || false,
      wellness: wellnessBenefits.map(({ vendor }) => vendor.name),
      retirementInsurance: retirementInsuranceBenefit?.enabled || false,
      pensionPlan: pensionPlanBenefit?.enabled || false,
    },

    ...rest,
  };
}
